<template>
  <div class="paper-share-page-wrapper" :style="{ backgroundImage: bgUrl }" :class="[{ mobile: isMobile }, styleClass]">
    <template>
      <div class="paper-share-page-wrapper__login" v-if="!isMobile && showLogin === 1">
        <img v-if="isLogin" src="@imgs/share-mine.png" @click="$router.push({ path: '/personal' })" alt="我的主页" />
        <img v-else src="@imgs/share-login.png" alt="登录注册" @click="goLogin" />
      </div>
    </template>
    <div class="title">
      {{ title }}
    </div>
    <div class="paper-share-page" v-if="!isMobile">
      <div class="btn left" :class="{ disabled: leftDisable }" @click="moveLeft()" v-if="totalPaper > 4"></div>
      <el-scrollbar ref="paperContent" class="paper-content">
        <div class="paper-list">
          <div class="paper-item" v-bind:key="index" v-for="(item, index) in paperList" @click="goDetail($event, item)">
            <img v-if="item.coverUrl" :src="item.coverUrl" style="height: 335px; width: 240px" />
            <div v-else class="no-cover">
              <p>暂无</p>
              <p>内容</p>
            </div>
            <div class="paper-name">{{ item.name }}</div>
          </div>
        </div>
      </el-scrollbar>
      <div class="btn right" :class="{ disabled: rightDisable }" @click="moveRight()" v-if="totalPaper > 4"></div>
    </div>
    <div class="paper-share-page mobile-content" @touchstart="carouselStart" @touchmove="carouselMove" @touchend="onSwipe" v-else>
      <el-carousel ref="imgCarousel" id="imgCarousel" class="paper-list" @change="indexChange" height="400px" arrow="never" type="card" :autoplay="false" indicator-position="none">
        <el-carousel-item v-for="(item, index) in paperList" :key="index">
          <div class="paper-item_mobile" @click="goDetail($event, item)">
            <img v-if="item.coverUrl" :src="item.coverUrl" style="height: 380px; width: 280px" />
            <div v-else class="no-cover">
              <p>暂无</p>
              <p>内容</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="paper-name" v-if="paperList.length > 0">{{ paperList[currentIndex].name }}</div>
      <div class="paper-share-page-wrapper__footer__login" v-if="showLogin === 1">
        <img v-if="isLogin" src="@imgs/share-mine.png" @click="$router.push({ path: '/personal' })" alt="我的主页" />
        <img v-else src="@imgs/share-login.png" alt="登录注册" @click="goLogin" />
      </div>
      <div class="page-footer">
        <img class="footer-icon" src="@imgs/paper/go-first.png" @click="moveTo('first', 0)" title="" />
        <img class="footer-icon" src="@imgs/paper/go-pre.png" @click="moveTo('pre', currentIndex - 1)" />
        <div class="text">{{ currentIndex + 1 + '/' + totalPaper }}</div>
        <img class="footer-icon fd-footer-icon" src="@imgs/paper/go-next.png" @click="moveTo('next', currentIndex + 1)" />
        <img class="footer-icon fd-footer-icon" src="@imgs/paper/go-last.png" @click="moveTo('last', totalPaper - 1)" />
      </div>
    </div>
    <div class="paper-share-page-wrapper__footer" v-if="!isMobile && this.showShare === 1">
      <img src="@imgs/outer-share.png" alt="分享" @click="sharePaper" />
    </div>
    <share-dialog ref="shareAllDialog" :qrObj="qrObj" :showButtons="[false, false]" :typeName="typeName" :title="'分享数字报'"></share-dialog>
  </div>
</template>
<script>
import wxSetting from '@components/common/wxSetting'
import api from '@api/paperManager'
import ShareDialog from '@components/books/components/ShareDialog.vue'
import login from '@api/login'

export default {
  name: 'PaperSharePage',
  mixins: [wxSetting],
  data() {
    return {
      paperList: [],
      title: '报业集团',
      totalPaper: 0,
      showStyle: 1,
      openMode: 0,
      bgUrl: '',
      leftDisable: true,
      rightDisable: false,
      currentIndex: 0,
      currentPosition: 0,
      startX: 0,
      loginUrl: window.PROJECT_CONFIG.BASE_URL,
      moveX: 0,
      typeName: 'paper',
      showLogin: 1,
      showShare: 1,
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0,
        title: ''
      }
    }
  },
  components: { ShareDialog },
  watch: {
    currentIndex(val) {
      this.leftDisable = val === 0
      this.rightDisable = val + 4 >= this.totalPaper
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    userName() {
      return this.$route.query.user
    },
    isLogin() {
      return this.$store.state.common.isLogin
    },
    styleClass() {
      let className = ''
      switch (this.showStyle) {
        case 0:
          className = 'red'
          break
        case 1:
          className = 'blue'
          break
        default:
          className = 'blue'
      }
      return className
    }
  },
  created() {
    login.login().then((res) => {
      if (res && res.data && res.status === 200) {
        let data = res.data
        if (data.code === 101) {
          this.$store.commit('common/UPDATE_IS_LOGIN', false)
        } else if (data.data.username) {
          this.$store.commit('common/UPDATE_IS_LOGIN', true)
          localStorage.setItem('username', data.data.username)
        }
      }
    })
    this.init()
  },
  mounted() {
    let wxParams = {
      userName: this.userName,
      currentUrl: window.location.href
    }
    api.wxGroupShareParams(wxParams).then((res) => {
      if (res.data && res.data.status === 0) {
        const data = res.data.data
        this.setWXConfig(data)
      }
    })
  },
  methods: {
    async init() {
      const param = {
        userName: this.userName
      }
      api.shareDisplay(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.paperList = res.data.data
          this.totalPaper = this.paperList.length
        } else {
          this.paperList = []
        }
      })
      api.getGroupShareSetting(this.userName, 0).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          const data = res.data.data
          this.title = data.title
          this.showStyle = data.topicColor
          this.openMode = data.openMode
          let url = data.backgroud
          if (url) {
            if (url.length === 1 || url.length === 2) {
              url = require('@/assets/imgs/paper/bg' + url + '.png')
            }
            console.log(url)
            if (url.length > 1) {
              this.bgUrl = `url(${url})`
            }
          }
          if (data.switchGroup) {
            let switchGroup = JSON.parse(data.switchGroup)
            this.showLogin = switchGroup.login
            this.showShare = switchGroup.share
          }
        }
        document.title = this.title
      })
    },
    moveLeft() {
      if (this.currentIndex > 0) {
        this.currentIndex = Math.max(0, this.currentIndex - 4)
        this.$refs.paperContent.wrap.scrollLeft = 260 * this.currentIndex
      }
    },
    moveRight() {
      let el = this.$refs.paperContent.wrap
      if (this.currentIndex + 4 < this.totalPaper) {
        this.currentIndex = Math.min(this.currentIndex + 4, this.totalPaper - 4)
        el.scrollLeft = 260 * this.currentIndex
      }
    },
    moveTo(to, page) {
      switch (to) {
        case 'first':
          this.currentIndex = 0
          break
        case 'last':
          this.currentIndex = this.totalPaper - 1
          break
        case 'pre':
          if (this.currentIndex === 0) {
            this.currentIndex = this.totalPaper - 1
          } else {
            this.currentIndex--
          }
          break
        case 'next':
          if (this.currentIndex >= this.totalPaper - 1) {
            this.currentIndex = 0
          } else {
            this.currentIndex++
          }
          break
      }
      this.$refs.imgCarousel.setActiveItem(this.currentIndex)
    },
    indexChange(index) {
      this.currentIndex = index
    },
    carouselStart(event) {
      this.startX = event.touches[0].clientX
    },
    carouselMove(event) {
      this.moveX = event.touches[0].clientX
    },
    onSwipe(event) {
      if (this.moveX === 0 || this.startX === 0) {
        this.startX = 0
        this.moveX = 0
        return
      }
      if (this.moveX - this.startX > 100) {
        this.moveTo('pre')
        event.stopPropagation()
      } else if (this.moveX - this.startX < -100) {
        this.moveTo('next')
        event.stopPropagation()
      }
      this.startX = 0
      this.moveX = 0
    },
    goDetail(event, item) {
      event.preventDefault()
      let id = item.id
      if (!item.updateWorkId) {
        this.$alert('暂无可浏览内容', '提示', {
          confirmButtonText: '确定'
        })
        return
      }
      let ua = window.navigator.userAgent.toLowerCase()
      let a = document.createElement('a')
      if (this.openMode === 0 || (this.isMobile && ua.match(/MicroMessenger/i) == 'micromessenger')) {
        sessionStorage.setItem('userName', this.userName)
        localStorage.setItem('from', 'paperGroup')
      } else {
        a.target = '_blank'
      }
      setTimeout(() => {
        const link = `/ebook/baozhi/index.jhtml?id=${id}&openMode=${this.openMode}&from=paperGroup`
        a.href = link
        a.click()
      })
      event.stopPropagation()
    },
    goLogin() {
      window.location.href = this.loginUrl + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href)
    },
    sharePaper() {
      this.$refs.shareAllDialog.dialogVisible = true
      this.qrObj.value = window.location.href.replace('list', 'paperSharePage?user=' + this.userName)
    }
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0px !important;
  border-radius: 10px !important;
  background-color: #fed79c !important;
  z-index: 0 !important;
}
.paper-share-page-wrapper {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  text-align: center;
  background-image: url('../assets/imgs/paper/share_bg_blue.png');
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  overflow-y: scroll;
  .title {
    margin: 100px auto 0 auto;
    max-width: 400px;
    height: 71px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #ffffff;
    background-image: url('../assets/imgs/paper/share_title-bg_blue.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    z-index: 2;
    position: relative;
  }
  &__login {
    float: right;
    padding: 40px 40px 0;
    cursor: pointer;
  }
  &__footer {
    margin: 30px;
    text-align: right;
    img {
      cursor: pointer;
    }
    &__login {
      width: 340px;
      text-align: left;
      position: absolute;
      bottom: 50px;
    }
  }
  .paper-share-page {
    max-width: 1200px;
    margin: -10px auto 0 auto;
    background-color: rgba(255, 255, 255, 0.4);
    height: 480px;
    border-radius: 10px;
    padding: 50px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .btn {
      width: 31px;
      height: 120px;
      background-repeat: no-repeat;
      background-size: contain;
      cursor: pointer;
      &.left {
        background-image: url('../assets/imgs/paper/btn_left.png');
      }
      &.right {
        background-image: url('../assets/imgs/paper/btn_right.png');
      }
      &.disabled {
        cursor: not-allowed;
        background-color: rgba(180, 180, 180, 0.6);
      }
    }
    .no-cover {
      background-image: url('../assets/imgs/al_morebook1@2x.png');
      background-repeat: no-repeat;
      background-size: 105% 105%;
      background-position: 0 -10px;
      font-size: 30px;
      color: #999999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      p {
        margin: 0;
      }
    }
    .paper-content {
      max-width: 1039px;
      overflow-y: hidden;
      overflow-x: hidden;
      .paper-list {
        display: flex;
        flex-direction: row;
        .paper-item {
          margin-left: 20px;
          height: 375px;
          position: relative;
          cursor: pointer;
          &:first-child {
            margin-left: 0;
          }
          .paper-name {
            position: absolute;
            bottom: 0;
          }
        }
      }
      &.books-mobile {
        width: 100%;
        height: 100%;
      }
      .no-cover {
        height: 335px;
        width: 240px;
      }
    }
    .paper-name {
      margin: 0 auto;
      color: #3a3a3a;
      font-size: 16px;
      width: 240px;
      min-height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.4);
      border-radius: 10px;
    }
    &.mobile-content {
      background-color: unset;
      width: calc(100vw - 30px);
      display: block;
      min-height: 380px;
      height: 550px;
      overflow-x: hidden;
      margin: 0 15px;
      .paper-item_mobile {
        height: 380px;
        width: 280px;
      }
      .paper-name {
        margin-top: 10px;
      }
      .no-cover {
        height: 380px;
        width: 280px;
      }
    }
  }
  &.red {
    background-image: url('../assets/imgs/paper/share_bg_red.png');
    .title {
      background-image: url('../assets/imgs/paper/share_title-bg_red.png');
    }
    .paper-share-page {
      .btn {
        &.left {
          background-image: url('../assets/imgs/paper/btn_left_red.png');
        }
        &.right {
          background-image: url('../assets/imgs/paper/btn_right_red.png');
        }
      }
    }
  }
  &.mobile {
    background-size: auto 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &.red {
    }
    .title {
      width: 261px;
      min-height: 47px;
      max-height: 70px;
      height: auto;
      margin-top: 10px;
      padding: 5px;
      font-size: 16px;
    }
    .page-footer {
      position: fixed;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40px;
      text-align: center;
      background-color: #eeeeee;
      .footer-icon {
        width: 26px;
        height: 26px;
        vertical-align: middle;
        margin-right: 20px;
      }
      .text {
        color: #515151;
        display: block;
        font-size: 12px;
        background-color: #ffffff;
        width: 70px;
        height: 26px;
        line-height: 26px;
      }
    }
  }
}
</style>
<style lang="scss">
.paper-share-page-wrapper {
  .el-scrollbar {
    .el-scrollbar__bar {
      display: none !important;
    }
    .el-scrollbar__wrap {
      //margin-bottom: -16px !important;
    }
  }
  .el-carousel {
    width: 600px;
    margin-left: calc(50vw - 315px);
    .el-carousel__item {
      width: 280px;
      background-color: #999999;
      height: 380px;
      &.is-active {
        margin: 0 auto;
        z-index: 999;
      }
    }
  }
}
</style>
<!-- 移动端 -->
<style lang="scss" scoped>
.mobile {
}
</style>
